export default __webpack_public_path__ + "static/media/adminPanelDesign.b7dcf8a7.jpg";